import React from 'react';
import { EyeIcon } from '@heroicons/react/20/solid';

const PresupuestoCard = ({ presupuesto, handleVerPresupuesto }) => {
    return (
        <div
            key={presupuesto.id}
            className="bg-base-300 rounded-lg shadow-md p-4  dark:border-gray-700 transition hover:shadow-lg"
        >
            <div className="flex justify-between items-center mb-2">
                <h3 className="text-lg font-semibold dark:text-gray-300">Presupuesto #{presupuesto.id}</h3>
                <span className="text-sm text-gray-500 dark:text-gray-400">
                    {presupuesto.fecha_creacion}
                </span>
            </div>
            <p className="text-sm mb-2 dark:text-gray-300">{presupuesto.descripcion}</p>
            <div className="flex justify-between items-center">
                <span className={`text-sm font-medium ${presupuesto.aprobado ? 'text-green-600' : 'text-error'}`}>
                    {presupuesto.aprobado ? 'Aprobado' : 'No Aprobado'}
                </span>
                <button
                    className="bg-green-500 text-white py-1 px-3 rounded-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-50 dark:bg-green-600 dark:hover:bg-green-700 transition duration-200 ease-in-out"
                    onClick={() => handleVerPresupuesto(presupuesto.id)}
                >
                    <EyeIcon className="w-5 h-5" />
                </button>
            </div>
        </div>
    );
};

export default PresupuestoCard;
